<template>
  <header :class="{ active: isActive }">
    <div class="container nav-container">
      <b-navbar
        toggleable="true"
        type
      >
        <b-navbar-toggle target="nav-collapse" />
        <b-navbar-brand>
          <router-link
            to="/home"
            class-active="active"
          >
            <img
              src="../assets/img/logo.svg"
              alt="Roosterplatform Logo"
            >
          </router-link>
        </b-navbar-brand>
        <b-collapse
          id="nav-collapse"
          v-model="showCollapse"
          is-nav
        >
          <router-link
            to="/product"
            class-active="active"
          >
            Product
          </router-link>
          <router-link
            to="/clients"
            class-active="active"
          >
            Klanten
          </router-link>
          <router-link
            to="/about-us"
            class-active="active"
          >
            Over ons
          </router-link>
          <router-link to="/blog">
            Blog
          </router-link>
          <router-link
            to="/contact"
            class-active="active"
          >
            Contact
          </router-link>
          <a
            href="https://support.roosterplatform.nl/portal/nl/signin#home"
            target="blank"
          >Helpdesk</a>
        </b-collapse>

        <div class="main-menu">
          <router-link
            to="/product"
            class-active="active"
          >
            Product
          </router-link>
          <router-link
            to="/clients"
            class-active="active"
          >
            Klanten
          </router-link>
          <router-link
            to="/about-us"
            class-active="active"
          >
            Over ons
          </router-link>
          <router-link
            to="/blog"
            class-active="active"
          >
            Blog
          </router-link>
          <a
            href="https://support.roosterplatform.nl"
            target="blank"
          >Helpdesk</a>
        </div>
        <b-button
          to="/contact"
          class="button secondary-button contact-button"
        >
          Contact
        </b-button>

        <router-link
          to="/demo"
          class="button primary-button demo-button"
          tag="button"
        >
          Vraag demo aan
        </router-link>
      </b-navbar>
    </div>
  </header>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      scrollPosition: 0,
      showCollapse: false,
    };
  },
  computed: {
    showCTA() {
      if (
        [
          "coach-profile",
          "coaches",
          "exclusive-coach",
          "hire-coach-form",
          "payment_successful",
          "pricing",
        ].includes(this.$route.name)
      ) {
        return false;
      }
      return true;
    },
    isActive() {
      return this.scrollPosition > 200;
    },
  },
  watch: {
    $route() {
      this.showCollapse = false;
    },
  },
  created() {
    let self = this;
    window.addEventListener("click", function (e) {
      // close dropdown when clicked outside
      // if (self.showCollapse){
      //   self.showCollapse = false;
      // }
      if (!self.$el.contains(e.target)) {
        self.showCollapse = false;
      }
    });
  },
  mounted() {
    window.addEventListener("scroll", this.updateScroll);
  },
  destroy() {
    window.removeEventListener("scroll", this.updateScroll);
  },
  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    signUp() {
      this.$ma.trackEvent({
        fb_event: "Lead",
        category: "Menu",
        action: "Menu",
        label: "Signup",
        type: "Signup",
      });
      window.open(
        `${process.env.VUE_APP_APP_BASE_URL}/sign-up?utm_source=website&utm_medium=Home`
      );
    },
    signIn() {
      this.$ma.trackEvent({
        fb_event: "Login",
        category: "Menu",
        action: "Menu",
        label: "Signin",
        type: "Signin",
      });
      window.open(
        `${process.env.VUE_APP_APP_BASE_URL}/login?utm_source=website&utm_medium=Home`
      );
    },
    openDemoRequest() {
      this.$ma.trackEvent({
        fb_event: "Click",
        category: "Click",
        action: "Request Demo",
        label: "Sticky Header",
        type: "Sticky Header",
      });
      this.$router.push({ name: "request-demo" });
    },
  },
};
</script>
<style scoped lang="scss">
@import "../assets/css/colors.scss";
@import "../assets/css/variables.scss";

header {
  height: $header-height;
  transition: $transition;
  z-index: 2;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  background: $grey-light;

  &.active {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    height: 10px;
    height: $header-height - 10;

    .navbar-collapse {
      opacity: 0;
    }
  }
}

.contact-button {
  padding: 0;
  min-width: 100px;
}

.router-link-active {
  text-decoration: underline;
  font-weight: bold;
}

.main-menu {
  margin: 0 auto 0 0;
  display: flex;
  > a {
    margin-right: 30px;
    color: $text;
  }
}

.nav-container {
  display: flex;
  align-content: center;
  justify-content: center;
  height: 100%;
}

.navbar {
  padding: 0;
  width: 100%;

  &-toggler {
    display: none;
  }
  &-brand {
    img {
      max-width: 170px;
      margin-right: 20px;

      top: -2px;
      position: relative;
    }
  }
  &-collapse {
    transition: all 0.3s ease-in-out;
    background: #2b3060;
    position: absolute;
    top: 50px;
    padding: 0;
    right: 0;
    left: 0;
    border-radius: 4px;
    opacity: 1 !important;
    max-width: 300px;
    max-height: 90vh;
    overflow: auto;
    a,
    button {
      color: #fff;
      border: none;
      background: none;
      display: block;
      margin: 20px;
      font-weight: bold;
      padding: 0;
    }
    hr {
      border-top: 1px solid rgba(#fff, 0.2);
      margin: 20px;
    }
    .sign-up {
      b {
        color: #fff;
        font-weight: bold;
        margin: 20px;
        text-transform: uppercase;
        opacity: 0.5;
        display: block;
      }
      a,
      button {
        margin-left: 40px;
      }
    }
  }
}

@media (max-width: 1199px) {
}

@media (max-width: 991px) {
  header {
    height: $header-height-small;
    &.active {
      height: $header-height-small - 5;
      .demo-button {
        top: 6px;
        opacity: 1;
      }
    }
  }

  .navbar-toggler {
    display: block;
  }
  .navbar-brand {
    margin-right: auto;
  }
  .main-menu,
  .contact-button {
    display: none;
  }

  .demo-button {
    position: absolute;
    margin: 0 !important;
    width: auto;
    font-size: 14px;
    height: 0;
    min-width: 0;
    right: 0;
    top: 8px;
    padding: 16px;
    opacity: 0;
  }
}

@media (max-width: 767px) {
  header {
    background: $grey-light;
  }
  .navbar-brand {
    margin-left: 40px;
    img {
      max-width: 130px;
    }
  }
  .navbar-toggler {
    position: absolute;
    left: 0;
    padding-right: 0;
  }
}
</style>
